import './styles/navbar.scss'

import React       from 'react'
import PropTypes   from 'prop-types'
import { connect } from 'react-redux'

import {
  Dropdown,
  Menu,
} from 'semantic-ui-react'

import {
  setSelectedCategory,
} from '../redux/actions/items'

import {
  logout,
} from '../redux/actions/auth'

import { mapCategoryPaths } from '../routeUtils'

function hasFeatureFlag({ featureFlags, featureFlag }) {
  return !featureFlag || (featureFlag && featureFlags.includes(featureFlag))
}

class Navbar extends React.Component {
  static propTypes = {
    history:             PropTypes.object.isRequired,
    user:                PropTypes.object.isRequired,
    logout:              PropTypes.func.isRequired,
    categories:          PropTypes.array.isRequired,
    featureFlags:        PropTypes.array.isRequired,
    selectedCategory:    PropTypes.string,
    setSelectedCategory: PropTypes.func.isRequired,    
  }

  constructor(props) {
    super(props)

    props.history.listen((location) => {
      const path          = location.pathname.replace('/', '')
      const categoryPaths = mapCategoryPaths(this.props.categories)

      const category = Object.keys(categoryPaths).find((key) => categoryPaths[key] === path)

      if (category && category !== this.props.selectedCategory) {
        this.props.setSelectedCategory(category)
      }
    })
  }

  handleCategorySelected = (key) => {
    const categoryPaths = mapCategoryPaths(this.props.categories)
    
    this.props.history.push(`/${categoryPaths[key]}`)
    this.props.setSelectedCategory(key)
  }

  handleLogout = () => {
    this.props.logout()
  }

  renderMenuItem = ({ key, label, enabled, selectedCategory, children }) => {
    return children
      ? this.renderMenuDropdownItem({ key, label, enabled, selectedCategory, children })
      : this.renderMenuSimpleItem({ key, label, enabled, selectedCategory })
  }

  renderMenuDropdownItem = ({ key, label, selectedCategory, children }) => {
    const featureFlags = this.props.featureFlags

    return (
      <Dropdown key={key} text={label}>
        <Dropdown.Menu>
          {
            children
              .filter(({ featureFlag }) => hasFeatureFlag({ featureFlag, featureFlags }))
              .filter(({ roles }) => roles.includes(this.props.user.role))
              .map(({ key, label, enabled }) => {
              const handleCategorySelected = () => this.handleCategorySelected(key)
              const active = key === selectedCategory

              return <Dropdown.Item
                key={key}
                text={label}
                onClick={handleCategorySelected}
                disabled={!enabled}
                active={active} />
            })
          }
        </Dropdown.Menu>
      </Dropdown>
    )
  }

  renderMenuSimpleItem = ({ key, label, enabled, selectedCategory }) => {
    const handleCategorySelected = () => this.handleCategorySelected(key)
    const active = key === selectedCategory

    return <Menu.Item
      key={key}
      name={label}
      active={active}
      onClick={handleCategorySelected}
      disabled={!enabled}
    />
  }

  render() {
    const { categories, selectedCategory, featureFlags } = this.props

    return (
      <div className="navbar-component">
        <Menu secondary size='small'>
          <Menu.Menu position='left'>
            {
              categories
                .filter(({ utilities }) => !utilities)
                .filter(({ featureFlag }) => hasFeatureFlag({ featureFlag, featureFlags }))
                .filter(({ roles }) => roles.includes(this.props.user.role))
                .map(({ key, label, enabled, roles, children }) =>
                  this.renderMenuItem({ key, label, enabled, roles, selectedCategory, children })
                )
            }
          </Menu.Menu>

          <Menu.Menu position='right'>
              {
                categories  
                  .filter(({ utilities }) => utilities)
                  .filter(({ featureFlag }) => hasFeatureFlag({ featureFlag, featureFlags }))
                  .filter(({ roles }) => roles.includes(this.props.user.role))
                  .map(({ key, label, enabled, children }) =>
                    this.renderMenuItem({ key, label, enabled, selectedCategory, children })
                  )
              }
            <Menu.Item
              name="Logout"
              active={false}
              onClick={this.handleLogout}
            />
          </Menu.Menu>
        </Menu>
      </div>
    )
  }
}

const mapDispatchToProps = {
  setSelectedCategory,
  logout,
}
const mapStateToProps = (state) => ({
  user:             state.auth.user,
  categories:       state.items.categories,
  featureFlags:     state.features.featureFlags,
  selectedCategory: state.items.selectedCategory,
})

export default connect(mapStateToProps, mapDispatchToProps)(Navbar)